import { ConfigHelper } from "./src/helpers/config-helper";
import Subscribe from "./src/views/Subscribe.svelte";
import PushHelper from "./src/helpers/push-helper";

interface IConfig {
    isDebug: Boolean;
    domNode: Node;
    domNodeAnchor: Node;
    modal: {
        message: String,
        refuseText: String,
        subscribeText: String,
        icon: Node;
        css: String;
    };
    packageName: String;
    pSetup: String;
    verBBE: String;
    registrationHost: String;
    apns: {
        webServiceUrl: String,
        pushId: String
    };
    fcm: {
        appId: String,
        apiKey: String,
        projectId: String,
        senderId: String,
        baseURL: String,
        vapidKey: String
    };
}

class TaPushInterface {
    _config: IConfig = {};

    /**
     * initialize instance and check if config is valid
     */
    _makeInstance = async () => {
        try {
            PushHelper.getInstance(this._config);
            PushHelper.getInstance().validate();
            await PushHelper.getInstance().init();
        } catch (e) {
            this._onError(e);
        }
    };

    async init(config: IConfig = {}) {
        this._config = config;
        await this._makeInstance();
        try {
            const asked = await ConfigHelper.isSubscribePopupShown();
            if (!asked || this._config.isDebug) {
                if (!PushHelper.getInstance().hasNotPermission()) {
                    this._showPopup();
                }
            } else {
                const agree = await ConfigHelper.hasUserAgreePush();
                if (!agree) {
                    //user not agrees popup, but changes notification permission for the website
                    if (PushHelper.getInstance().hasPermission()) {
                        console.log("User change system permission and granted push");
                        await this._onSubscribe();
                    } else {
                        this._onError(new Error("User already rejected subscription"));
                    }
                } else if (PushHelper.getInstance().hasPermission()) {
                    const token = await ConfigHelper.getToken();
                    if (token) {
                        await this._checkToken(token);
                    } else {
                        //user agrees popup, but missing token
                        await this._onSubscribe();
                    }
                } else {
                    await ConfigHelper.clearAll();
                    this._onError(new Error("User denied permission, clear all previous data"));
                }
            }
        } catch (e) {
            this._onError(e);
        }
    }

    /**
     * start request permission flow
     */
    _requestPermission = async () => {
        const token = await PushHelper.getInstance().requestPermission();
        await this._checkToken(token);
    };

    /**
     * check device registration
     * if not exists, or failed, or has too old
     */
    _checkToken = async (token) => {
        await ConfigHelper.updateToken(token);
        const { success, time } = await ConfigHelper.getDeviceRegistration();
        if (!success || !time || time < new Date().getTime() - 2 * 60 * 60 * 1000) {
            await PushHelper.getInstance().registerDevice(token);
        }
        console.debug(`Token: ${token}`);
        this._onToken(token);
    };

    /**
     * show a popup that ask to user if he want subscribe to push notification
     */
    _showPopup = () => {
        new Subscribe({
            target: this._config.domNode || document.body,
            anchor: this._config.domNodeAnchor || null,
            props: {
                modal: this._config.modal,
                onSubscribe: this._onSubscribe,
                onRefuse: this._onRefuse
            }
        });
    };

    _onSubscribe = async () => {
        try {
            await this._requestPermission();
            ConfigHelper.storeSubscribePopup(true);
        } catch (e) {
            this._onError(e);
        }
    };

    _onRefuse = async () => {
        ConfigHelper.storeSubscribePopup(false);
        this._onError(new Error("user reject push permission"));
    };

    _onError = (error) => {
        setTimeout(() => {
            if (this._config && typeof this._config.onError) {
                this._config.onError(error);
            }
        }, 0);
    };

    _onToken = (token) => {
        setTimeout(() => {
            if (this._config && typeof this._config.onToken === "function") {
                this._config.onToken(token);
            }
        }, 0);
    };
}

window.TecnaviaPush = new TaPushInterface();
